export const QUERY_KEYS = {
  GLOBAL: {
    FETCH_ENUM: "GLOBAL_FETCH_ENUM",
    MASTER_DATA: "MASTER_DATA",
    MASTER_REGION: "MASTER_REGION",
    MASTER_NATIONALITY: "MASTER_NATIONALITY",
    MASTER_LIVING_RELATIONSHIP: "MASTER_LIVING_RELATIONSHIP",
    MASTER_MAIN_OCCUPATION: "MASTER_MAIN_OCCUPATION",
    MASTER_MAIN_INDUSTRY: "MASTER_MAIN_INDUSTRY",
    MASTER_LOCAL_GOVERNMENT_COUNTER: "MASTER_LOCAL_GOVERNMENT_COUNTER",
    MASTER_LANGUAGE_TEST: "MASTER_LANGUAGE_TEST",
    MASTER_SUPPORT_LANGUAGE: "MASTER_SUPPORT_LANGUAGE",
    MASTER_SKILL_TEST: "MASTER_SKILL_TEST",
    MASTER_SPECIFIC_INDUSTRY: "MASTER_SPECIFIC_INDUSTRY",
    MASTER_MAJOR: "MASTER_MAJOR",
    MASTER_COMPANY_SPECIFIC_INDUSTRY: "MASTER_COMPANY_SPECIFIC_INDUSTRY",
    MASTER_RESIDENCE_STATUS: "MASTER_RESIDENCE_STATUS",
    PROVINCES_MUNICIPALITIES: "GLOBAL_PROVINCES_MUNICIPALITIES",
    ENCRYPT_SECRET_KEY: "ENCRYPT_SECRET_KEY",
  },
  ADMIN_USER: {
    FETCH_LIST: "ADMIN_USER_FETCH_LIST",
    FETCH_DETAIL: "ADMIN_USER_FETCH_DETAIL",
  },
  MASTER_DATA: {
    FETCH_LIST: "MASTER_DATA_FETCH_LIST",
    FETCH_PRODUCT_LIST: "MASTER_DATA_FETCH_PRODUCT_LIST",
    FETCH_PRODUCT_DETAIL: "MASTER_DATA_FETCH_PRODUCT_DETAIL",
  },
  PRODUCT: {
    FETCH_LIST: "PRODUCT_FETCH_LIST",
  },
  ORGANIZATION_USER: {
    FETCH_LIST: "USER_FETCH_LIST",
    FETCH_ADMIN_LIST: "ADMIN_USER_FETCH_LIST",
    FETCH_PRODUCT_USER_LIST: "ORGANIZATION_PRODUCT_USER_FETCH_LIST",
    FETCH_DETAIL: "ORGANIZATION_USER_FETCH_DETAIL",
  },
  INFORMATION: {
    FETCH_LIST: "INFORMATION_FETCH_LIST",
    FETCH_DETAIL: "INFORMATION_FETCH_DETAIL",
  },
  FILE: {
    FETCH_SIGNED_URL: "FETCH_SIGNED_URL",
    FETCH_DETAIL: "FILE_FETCH_DETAIL",
    FETCH_INFO: "FILE_FETCH_INFO",
  },
  USER: {
    FETCH_ME: "USER_FETCH_ME",
  },
  CONVERT: {
    FETCH_DETAIL: "CONVERT_FETCH_DETAIL",
    FETCH_LIST: "CONVERT_FETCH_LIST",
    FETCH_ACCEPTANCE_ACTIVITY_DETAIL: "CONVERT_FETCH_ACCEPTANCE_ACTIVITY_DETAIL",
    FETCH_LIFE_SUPPORT_DETAIL: "CONVERT_FETCH_LIFE_SUPPORT_DETAIL",
  },
  CONTACT: {
    FETCH_DETAIL: "CONTACT_FETCH_DETAIL",
    FETCH_LIST: "CONTACT_FETCH_LIST",
  },
  CONTACT_TYPE: {
    FETCH_LIST: "CONTACT_TYPE_FETCH_LIST",
    FETCH_DETAIL: "CONTACT_TYPE_FETCH_DETAIL",
  },
  ORGANIZATION: {
    FETCH_LIST: "ORGANIZATION_FETCH_LIST",
    FETCH_DETAIL: "ORGANIZATION_FETCH_DETAIL",
    FETCH_ASSIGNABLE_USERS: "ORGANIZATION_FETCH_ASSIGNABLE_USERS",
  },
  PRODUCT_CONTRACT: {
    FETCH_LIST_BY_ORGANIZATION: "PRODUCT_CONTRACT_FETCH_LIST_BY_ORGANIZATION",
  },
  SYSTEM_SETTING: {
    FETCH_SYSTEM_DETAIL: "SYSTEM_SETTING_FETCH_SYSTEM_DETAIL",
    FETCH_MAINTENANCE_DETAIL: "SYSTEM_SETTING_FETCH_MAINTENANCE_DETAIL",
  },
  CONVERSATION: {
    FETCH_LIST: "CONVERSATION_FETCH_LIST",
    FETCH_DETAIL: "CONVERSATION_FETCH_DETAIL",
    FETCH_MESSAGE_LIST: "CONVERSATION_FETCH_MESSAGE_LIST",
  },
} as const;
